import baseApi from "./baseApi.js";
import axios from '@/models/API/axios'
import * as apiUrl from './apiUrl.js';

/**
 * 舊系統api
 */
class oldSystemApi extends baseApi {
    constructor() {
        super();
        this.baseApi = new baseApi();
    }

    /**
      * 查詢舊系統-契約LOG
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getOld17Logs(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_OLD_1_7_LOGS}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 查詢舊系統-查詢契約繳費通知地址LOG
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getOld18Logs(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_OLD_1_8_LOGS}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 查詢舊系統-入會費LOG
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getOld27Logs(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_OLD_2_7_LOGS}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 查詢舊系統-互助金LOG
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getOld37Logs(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_OLD_3_7_LOGS}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
      * 查詢舊系統-業務LOG
      * @param {Object.<string, string>} callback
      * @param {Object.<string, string>} params 查詢參數
      */
    getOld57Logs(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_OLD_5_7_LOGS}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

}

export default oldSystemApi;



// WEBPACK FOOTER //
// ./src/models/API/oldSystemApi.js